import { HTMLElementBase } from './HTMLElementBase';
import {HTMLElement} from "./HTMLElement";
export class HTMLLabelElement extends HTMLElement { constructor(tagName: string = 'LABEL', ownerDocument?: any) { super(tagName, ownerDocument); } }
